<template>
	<Col>
		<h2 class="heavy mb-3 feature-description-preview-title">Preview</h2>
		<Col class="preview-container">
			<Row class="tabs-row flex-align-center px-3">
				<AnemicButton
					tile
					class="tab-button pa-1"
					v-for="(tab, i) in tabs"
					@click="() => (selectedTabIndex = i)"
					:key="`${tab.title}-preview-tab-${i}`"
					:class="{ 'ml-9': i !== 0, selected: selectedTabIndex === i }"
				>
					{{ tab.title }}
				</AnemicButton>
			</Row>
			<v-slide-x-transition mode="out-in">
				<component :workflow="workflow" :is="tabs[selectedTabIndex].component" :onboardingText="onboardingText" />
			</v-slide-x-transition>
		</Col>
	</Col>
</template>

<script>
import WorkflowService from '@/utils/WorkflowService';
import FeatureDescriptionDetailsPage from '@/components/dialogs/OnboardingTextEditorDialog/FeatureDescriptionPreview/FeatureDescriptionDetailsPage.vue';
import FeatureDescriptionOnboardingOverlay from '@/components/dialogs/OnboardingTextEditorDialog/FeatureDescriptionPreview/FeatureDescriptionOnboardingOverlay.vue';
import FeatureDescriptionSharingNotificationPreview from '@/components/dialogs/OnboardingTextEditorDialog/FeatureDescriptionPreview/FeatureDescriptionSharingNotificationPreview.vue';
export default {
	name: 'FeatureDescriptionPreview',
	components: {
		FeatureDescriptionDetailsPage,
		FeatureDescriptionOnboardingOverlay,
		FeatureDescriptionSharingNotificationPreview,
	},
	props: {
		workflow: { type: Object },
		onboardingText: { type: String },
	},
	computed: {
		tabs() {
			return [
				{
					title: 'Onboarding overlay',
					component: FeatureDescriptionOnboardingOverlay,
					hide: !WorkflowService.isOfTypeFeature(this.workflow),
				},
				{
					title: 'Details page',
					component: FeatureDescriptionDetailsPage,
				},
				{
					title: 'Sharing notification',
					component: FeatureDescriptionSharingNotificationPreview,
				},
			].filter((tab) => !tab.hide);
		},
	},
	data() {
		return { selectedTabIndex: 0 };
	},
};
</script>

<style scoped lang="scss">
.preview-container {
	height: 310px;
	border-radius: 6px;
	background: #f9fafc;
	border: 1px solid #e7eaf3;
}
.tabs-row {
	min-height: 40px;
	background: #ffffff;
	border-bottom: 1px solid #e7eaf3;
	border-radius: 6px 6px 0px 0px;
}
.tab-button {
	height: 42px !important;
	font-size: 14px !important;
	color: #666767 !important;
	border-radius: 0px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	text-transform: none !important;
	background: transparent !important;
	transition: var(--transition-time) !important;
	border-bottom: 2px solid transparent !important;
	&.selected {
		color: #303133 !important;
		font-weight: 600 !important;
		border-color: #303133 !important;
		transition: var(--transition-time) !important;
	}
}
</style>
